import { render, staticRenderFns } from "./MatchGameCards.vue?vue&type=template&id=37ff5c54&"
import script from "./MatchGameCards.vue?vue&type=script&lang=js&"
export * from "./MatchGameCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports